import AsyncStorage from '@react-native-async-storage/async-storage';
import { create } from 'zustand';
import { VideoPost } from '../types/video';

const HISTORY_KEY = '@video_history';
const MAX_HISTORY_ITEMS = 50;

interface HistoryItem extends VideoPost {
  viewedAt: string;
}

interface HistoryState {
  history: HistoryItem[];
  loading: boolean;
  loadHistory: () => Promise<void>;
  addToHistory: (video: VideoPost) => Promise<void>;
  clearHistory: () => Promise<void>;
}

export const useHistoryStore = create<HistoryState>((set, get) => ({
  history: [],
  loading: false,

  loadHistory: async () => {
    try {
      set({ loading: true });
      const stored = await AsyncStorage.getItem(HISTORY_KEY);
      if (stored) {
        const history = JSON.parse(stored);
        set({ history });
      }
    } catch (error) {
      console.error('Failed to load history:', error);
    } finally {
      set({ loading: false });
    }
  },

  addToHistory: async (video: VideoPost) => {
    try {
      const { history } = get();
      const newItem: HistoryItem = {
        ...video,
        viewedAt: new Date().toISOString(),
      };
      
      // 重複を除去して先頭に追加、最大件数に制限
      const updated = [newItem, ...history.filter(item => item.id !== video.id)].slice(0, MAX_HISTORY_ITEMS);
      
      await AsyncStorage.setItem(HISTORY_KEY, JSON.stringify(updated));
      set({ history: updated });
    } catch (error) {
      console.error('Failed to add to history:', error);
    }
  },

  clearHistory: async () => {
    try {
      await AsyncStorage.removeItem(HISTORY_KEY);
      set({ history: [] });
    } catch (error) {
      console.error('Failed to clear history:', error);
    }
  },
}));
